import Navbar from '../Navbar/Navbar'
import BackgroundImage from '../BackgroundImage/BackgroundImage'
import Description from '../Description/Description'
import Gallery from '../Gallery/Gallery'
import Contact from '../Contact/Contact'
import Footer from '../Footer/Footer'
import FeaturesAccordion from '../FeaturesAccordion/FeaturesAccordion'

const LandingPage = () => (
  <>
    <Navbar/>
    <BackgroundImage/>
    <Description/>
    <FeaturesAccordion/>
    <Gallery/>
    <Contact/>
    <Footer/>
  </>
)

export default LandingPage